export const previewLabel = (
  label: string | undefined,
  required: boolean,
  toOptional: (trimmed: string) => string,
): string => {
  const trimmed = label?.trim() ?? '';
  if (!trimmed) return '';
  return required ? trimmed : toOptional(trimmed);
};
